import styles from "./SitePage.module.css";

import {
  Button,
  DialogSurface,
  Dropdown,
  FeedbackForm,
  PageTitle,
  parseSelectedSitesFromSearch,
  useSelectedSites,
} from "@abb-connect/react-shared";
import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router";

import ServiceSelector from "@components/ServiceSelector";
import { parseProductionAreaFromSearch } from "@services/routes";

export default function SitePage() {
  const { search } = useLocation();
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  const { selectedSites, setSelected } = useSelectedSites();

  const urlSites = parseSelectedSitesFromSearch(search);
  const sites = urlSites.length > 0 ? urlSites : selectedSites;
  const productionArea = parseProductionAreaFromSearch(search, sites);

  useEffect(() => {
    if (urlSites.length === 0) return;
    if (
      urlSites.length === selectedSites.length &&
      urlSites.every((site, i) => site === selectedSites[i])
    ) {
      return;
    }
    setSelected(urlSites);
    // eslint-disable-next-line react-x/exhaustive-deps, react-hooks/exhaustive-deps
  }, [search]);

  const isMultiSite = sites.length > 1;

  if (sites.length === 0) {
    return <Navigate to={{ pathname: "/", search }} replace />;
  }

  const site = sites[0];

  const title =
    sites.length > 2
      ? `${sites.length} sites selected`
      : isMultiSite
        ? sites.join(", ")
        : site;
  const subtitle = isMultiSite
    ? "Some services support multiple sites"
    : "What do you want to do today?";

  return (
    <div className={styles["site-page"]}>
      <PageTitle title={title} subtitle={subtitle} />
      <div className={styles.content}>
        <ServiceSelector site={site} productionArea={productionArea} />
      </div>
      <div className={styles["feedback-button"]}>
        <Dropdown
          anchor="right"
          position="top"
          isOpen={isFeedbackOpen}
          setIsOpen={setIsFeedbackOpen}
          variant="no-padding"
          dropdown={
            <DialogSurface
              variant="no-padding"
              className={styles["feedback-form-wrapper"]}
            >
              <FeedbackForm onCancel={() => setIsFeedbackOpen(false)} />
            </DialogSurface>
          }
        >
          <Button
            icon="Chat"
            variant="ghost"
            toggled={isFeedbackOpen}
            onClick={() => setIsFeedbackOpen((open) => !open)}
            size="small"
          >
            Give feedback
          </Button>
        </Dropdown>
      </div>
    </div>
  );
}
